<template><div><code-well-header>
  <dt-list-item-group
    heading="Example Heading"
    heading-class="d-fw-bold"
  >
    <dt-list-item
      navigation-type="tab"
    >
      item1
    </dt-list-item>
    <dt-list-item
      navigation-type="tab"
    >
      item2
    </dt-list-item>
    <dt-list-item
      navigation-type="tab"
    >
      item3
    </dt-list-item>
  </dt-list-item-group>
</code-well-header>
<h2 id="base-style" tabindex="-1" class="d-docsite--header-2">Base Style <a class="header-anchor d-link d-docsite--link d-link" href="#base-style" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">You should use this component when you have multiple list items you would like to group into different categories.</p>
<p class="d-docsite--paragraph">The heading is unstyled by default. You will likely have to pass utility classes to the heading-class prop to make the heading look how you wish.</p>
<code-well-header>
  <dt-list-item-group
    heading="Example Heading"
    heading-class="d-fw-bold"
    ref="listItemGroup"
  >
    <dt-list-item
      navigation-type="tab"
    >
      item1
    </dt-list-item>
    <dt-list-item
      navigation-type="tab"
    >
      item2
    </dt-list-item>
    <dt-list-item
      navigation-type="tab"
    >
      item3
    </dt-list-item>
  </dt-list-item-group>
</code-well-header>
<code-example-tabs
:htmlCode='() => $refs.listItemGroup'
vueCode='
<dt-list-item-group
  heading="Example Heading"
  heading-class="d-fw-bold"
>
  <dt-list-item
    navigation-type="tab"
  >
    item1
  </dt-list-item>
  <dt-list-item
    navigation-type="tab"
  >
    item2
  </dt-list-item>
  <dt-list-item
    navigation-type="tab"
  >
    item3
  </dt-list-item>
</dt-list-item-group>
'
/>
<h2 id="accessibility" tabindex="-1" class="d-docsite--header-2">Accessibility <a class="header-anchor d-link d-docsite--link d-link" href="#accessibility" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">The List Item Group does not implement arrow-keys keyboard navigation. You will however get arrow-keys keyboard navigation when using this within list based Dialtone components such as Dropdown or Combobox.</p>
<p class="d-docsite--paragraph">The aria label for the List Item Group will be set by the content of the heading.</p>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="listitemgroup" /></div></template>


